export const BASKET_PAGE_HREF = '/cart';
export const FAVOURITES_PAGE_HREF = '/u/favourites';
